/// <amd-module name="Test/TestPlansHubRefresh/TestPlanCloneProgress/Redux/TestPlanCloneProgressReducer" />
import { default as produce } from "immer";
import { TestPlanCloneProgressActions, TestPlanCloneProgressActionsTypes } from "./TestPlanCloneProgressActions";
import { ITestPlanCloneProgressState } from "./TestPlanCloneProgressContracts";

/**
 * TestPlanCloneProgressReducer: Reducer which populates the aate related to clone progress state.
 * The base data includes the time elapsed, opid and state of the progress.
 */
export function TestPlanCloneProgressReducer(state: ITestPlanCloneProgressState, action: TestPlanCloneProgressActions): ITestPlanCloneProgressState {
    state = state || ({} as ITestPlanCloneProgressState);

    return produce(state, (draftState: ITestPlanCloneProgressState) => {
        switch (action.type) {
            case TestPlanCloneProgressActionsTypes.loadCloneOpStateSucceeded:
                draftState.state = action.payload.state;
                draftState.timeElapsed = state.timeElapsed ? state.timeElapsed + 1 : 1;
                break;

            default:
                break;
        }
    });
}
